<p-toast></p-toast>

<!-- Page Header -->
<div class="page-header">
  <div class="header-left">
    <button class="btn-back" type="button" (click)="goBack()" title="Back to Forms">
      <i class="ri-arrow-left-line"></i>
      <span>All Forms</span>
    </button>
    <h1 class="page-title">{{ templateName }}</h1>
  </div>
  <div class="header-actions">
    @if (canCreate) {
      <button class="btn-primary" type="button" (click)="openCreateFormModal()" [disabled]="isProjectInactive">
        <i class="ri-add-line"></i>
        <span>New Form</span>
      </button>
    }
  </div>
</div>

<!-- Forms Table -->
<div class="table-container">
  @if (loading) {
    <div class="table-loading">
      <i class="ri-loader-4-line ri-spin"></i>
      <span>Loading...</span>
    </div>
  } @else {
    <table class="data-table">
      <thead>
        <tr>
          <th class="col-template-id sortable" (click)="onSort('templateNameId')">
            <span>Template #</span>
            <i class="sort-icon" [class]="getSortIcon('templateNameId')"></i>
          </th>
          <th class="col-name sortable" (click)="onSort('name')">
            <span>Name</span>
            <i class="sort-icon" [class]="getSortIcon('name')"></i>
          </th>
          <th class="col-assigned sortable" (click)="onSort('assignedByName')">
            <span>Assigned By</span>
            <i class="sort-icon" [class]="getSortIcon('assignedByName')"></i>
          </th>
          <th class="col-date sortable" (click)="onSort('createdAt')">
            <span>Created Date</span>
            <i class="sort-icon" [class]="getSortIcon('createdAt')"></i>
          </th>
          <th class="col-status sortable" (click)="onSort('status')">
            <span>Status</span>
            <i class="sort-icon" [class]="getSortIcon('status')"></i>
          </th>
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (filteredForms.length === 0) {
          <tr>
            <td colspan="6">
              <div class="empty-state">
                <i class="ri-inbox-line"></i>
                <p class="empty-title">No forms found</p>
                <p class="empty-subtitle">Click "New Form" to create your first form</p>
              </div>
            </td>
          </tr>
        } @else {
          @for (form of filteredForms; track form.id; let odd = $odd) {
            <tr [class.row-alt]="odd">
              <td class="col-template-id">
                <span class="link-text" (click)="navigateToFormChecksheet(form)">
                  {{ templateName }} #{{ form.templateNameId }}
                </span>
              </td>
              <td class="col-name">
                <span class="cell-text">{{ form.name }}</span>
              </td>
              <td class="col-assigned">
                <span class="cell-text">{{ form.assignedByName || '-' }}</span>
              </td>
              <td class="col-date">
                @if (form.createdAt) {
                  <span class="cell-text">{{ formatDatabaseDate(form.createdAt) }}</span>
                } @else {
                  <span class="cell-text cell-text--muted">-</span>
                }
              </td>
              <td class="col-status">
                <span class="status-badge" [ngClass]="getStatusClass(form.status)">{{ form.status || 'Draft' }}</span>
              </td>
              <td class="col-actions">
                <div class="action-cell">
                  @if (canCreate) {
                    <button
                      class="action-icon-btn"
                      type="button"
                      (click)="openRenameDialog(form)"
                      [disabled]="isProjectInactive"
                      title="Rename form">
                      <i class="ri-pencil-line"></i>
                    </button>
                    <button
                      class="action-icon-btn"
                      type="button"
                      (click)="openCloneDialog(form)"
                      [disabled]="isProjectInactive"
                      title="Clone form">
                      <i class="ri-file-copy-line"></i>
                    </button>
                  }
                  <button
                    class="action-icon-btn action-icon-btn--delete"
                    type="button"
                    (click)="deleteForm(form)"
                    [disabled]="isProjectInactive"
                    title="Delete form">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
</div>

<!-- Rename Dialog -->
<p-dialog header="Rename Form" [(visible)]="showRenameDialog" [modal]="true" [style]="{width: '28rem'}" styleClass="kansei-dialog">
    <div class="modal-form-body">
        <div class="grid">
            <div class="col-12">
                <label for="renameFormName" class="modal-label">Form Name</label>
                <input id="renameFormName" type="text" pInputText [(ngModel)]="renameFormName" class="w-full" />
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="modal-btn-cancel" (click)="showRenameDialog = false">Cancel</button>
        <button type="button" class="modal-btn-primary" (click)="saveRenameForm()" [disabled]="!renameFormName.trim()">Save</button>
    </div>
</p-dialog>

<!-- Clone Dialog -->
<p-dialog header="Clone Form" [(visible)]="showCloneDialog" [modal]="true" [style]="{width: '28rem'}" styleClass="kansei-dialog">
    <div class="modal-form-body">
        <div class="grid">
            <div class="col-12">
                <label for="cloneFormName" class="modal-label">Form Name</label>
                <input id="cloneFormName" type="text" pInputText [(ngModel)]="cloneFormName" class="w-full" />
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="modal-btn-cancel" (click)="showCloneDialog = false">Cancel</button>
        <button type="button" class="modal-btn-primary" (click)="saveCloneForm()" [disabled]="!cloneFormName.trim()">Save</button>
    </div>
</p-dialog>
